import React from 'react'
import { HeaderPDF, Produto } from '../../../Utils/Types'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from "pdfmake/build/vfs_fonts"
import { Funcoes } from '../../../Utils/Funcoes'
import moment from 'moment'

export class ReportProductsPDF {

  private produtos: Produto[]
  private headers: HeaderPDF[]
  private dadosEmpresa: any
  private corpoDocumento: any
  private body: any
  private datai: any
  private dataf: any
  private nomeMarca: any
  private nomeGrupo: any
  private nomeSubGrupo: any
  private nomeTrib: any
  private tipoProduto: any
  private ativo: any
  private estoqueFisico: any

  constructor(produtos: Produto[], headers: HeaderPDF[], datai: string, dataf: string, nomeMarca: string, nomeGrupo: string, nomeSubGrupo: string, nomeTrib: string, tipoProduto: string, ativo: string, estoqueFisico: string) {
    this.produtos = produtos
    this.headers = headers
    this.body = []
    this.datai = datai ? moment(datai).format('DD/MM/YYYY') : datai
    this.dataf = dataf ? moment(dataf).format('DD/MM/YYYY') : dataf
    this.nomeMarca = nomeMarca
    this.nomeGrupo = nomeGrupo
    this.nomeSubGrupo = nomeSubGrupo
    this.nomeTrib = nomeTrib
    this.tipoProduto = tipoProduto === 'P' ? 'PRODUTO PARA REVENDA' : tipoProduto === 'S' ? 'SERVIÇOS' : tipoProduto === 'M' ? 'MATÉRIA PRIMA' : ''
    this.ativo = ativo === 'S' ? 'SIM' : ativo === 'N' ? 'NÃO' : ''
    this.estoqueFisico = estoqueFisico === '0' ? 'COM ESTOQUE' : estoqueFisico === '1' ? 'SEM ESTOQUE' : estoqueFisico === '2' ? 'ESTOQUE NEGATIVO' : estoqueFisico === '3' ? 'ATINGIU O ESTOQUE MÍNIMO' : ''
    this.CriaDocumento()
  }

  async CriaDocumento() {

    const bBody: any = this.produtos.map((prod) => {
      return [
        { text: prod.descricao, fontSize: 10 },
        { text: prod.referencia, fontSize: 10 },
        { text: prod.preco_v, fontSize: 10 },
        { text: prod.estoque_fisico, fontSize: 10 },
      ];
    });

    this.body = [
      { text: 'Teste1', fontSize: 10 },
      { text: 'Ref 001', fontSize: 10 },
      { text: "10,00", fontSize: 10 },
      { text: "50", fontSize: 10 },
    ];

    const lineHeader = [
      {
        text: '____________________________________________________________________________________________________________________________________________________________________________',
        aligment: 'center',
        fontSize: 5,
        colSpan: 3
      }, {}, {},
    ];

    let content = [this.headers, lineHeader];
    content = [...content, ...this.body];
    this.corpoDocumento = content;

    //return this.GerarDocumento(content);
  }

  GerarDocumento() {

    const document = {
      pageSize: 'A4',
      pageMargins: [14, 53, 14, 48],
      header: () => {
        return {
          margin: [14, 12, 14, 0],
          layout: 'noBorders',
          table: {
            widths: ['*'],
            body: [
              [
                { text: 'RELATÓRIO DE PRODUTOS', style: 'reportName' }
              ]
            ],
          },
        };
      },
      content: [
        {
          layout: 'noBorders',
          table: {
            headerRows: 1,
            widths: ['*', 55, 55],
            body: this.corpoDocumento
          }
        },
      ],
      footer: (currentPage: number, pageCount: number) => {
        return {
          layout: 'noBorders',
          margin: [14, 0, 14, 22],
          table: {
            widths: ['auto'],
            body: [
              [
                {
                  text: '_________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________',
                  alignment: 'center',
                  fontSize: 5,
                },
              ],
              [
                [
                  {
                    text: `Página ${currentPage.toString()} de ${pageCount}`,
                    fontSize: 7,
                    alignment: 'right',
                    // horizontal, vertical
                    margin: [3, 0],
                  },
                  {
                    text: '© Lojinha de TI',
                    fontSize: 7,
                    alignment: 'center',
                  },
                ],
              ],
            ],
          },
        };
      },
      styles: {
        reportName: {
          fontSize: 9,
          bold: true,
          alignment: 'center',
          margin: [0, 4, 0, 0],
        }
      },
    };

    return document;
  }

  async GerarPDF(produtos: Produto[]) {

    this.dadosEmpresa = Funcoes.GetDadosEmpresa()

    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    let dados = produtos.map((item: Produto) => {
      return [
        { text: item.descricao.length > 50 ? item.descricao.substring(0, 50).concat('...') : item.descricao, alignment: 'left', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, false, true], },
        { text: item.referencia || '', alignment: 'left', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, false, true], },
        { text: Funcoes.numberFormat(item.preco_v || 0, 'currency', 2, 2,), alignment: 'right', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, false, true], },
        { text: Funcoes.numberFormat(item.estoque_fisico || 0, 'decimal', 2, 2,), alignment: 'right', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, false, true], }];
    });

    const details: any = [
      {
        layout: 'noBorders',
        margin: 0,
        table: {
          widths: ['*', '*', '*', '*'],
          body: dados
        },
      }
    ];

    const titulo = (currentPage: any, pageCount: any, pageSize: any) => {
      return [
        {
          //margin: [0, 20, 0 , 0],  
          margin: 0,
          layout: 'noBorders',
          table: {
            headerRows: 2,
            widths: ['100%'],
            body: [
              [{ text: 'Relatório de Produto', alignment: 'center', fontSize: 20, style: 'header', margin: [0, 20, 0, 0] }],
              [{ text: 'Data: ' + (new Date()).toLocaleDateString('pt-BR'), alignment: 'right', fontSize: 12, margin: [0, 0, 30, 0] }],
              //[{text: 'Pág. '+currentPage + '/'+ pageCount, alignment: 'right', fontSize: 10,  margin: [0, 0, 20, 5]}],
              //[{text: 'Pág. 2 ', alignment: 'right', fontSize: 10,  margin: [0, 0, 20, 5]}],
            ]
          }
        },
        {
          layout: 'noBorders',
          margin: [0, 0, 0, 0],
          table: {
            widths: ['*', '*', '*', '*'],
            body: [
              [
                { text: 'Descrição', alignment: 'left', fontSize: 10, margin: [15, 0, 0, 0] },
                { text: 'Referência', alignment: 'left', fontSize: 10, },
                { text: 'Preço de Venda', alignment: 'right', fontSize: 10, },
                { text: 'Estoque', alignment: 'right', fontSize: 10, margin: [0, 0, 15, 0] },
              ],
            ]
          },
        },
        {
          margin: [15, 0, 15, 0],
          layout: 'noBorders',
          table: {
            widths: ['*'],
            body: [
              [{ text: '__________________________________________________________________________________________________________' }],
            ]
          },
        },
      ]
    };

    const footer = (currentPage: number, pageCount: number,) => {
      return [
        {
          layout: 'Borders',
          style: 'tableExample',
          margin: [50, 0, 50, 50],
          table: {
            headerRows: 1,
            widths: ['*', '*'],
            body: [
              [
                { text: 'Emissão: ' + moment(new Date()).format('DD/MM/YYYY HH:mm'), alignment: 'left', fontSize: 10, margin: [0, 0, 0, 0], border: [false, true, false, false] },
                { text: 'Pág. ' + currentPage + '/' + pageCount, alignment: 'right', fontSize: 10, margin: [0, 0, 0, 0], border: [false, true, false, false] },

              ],
            ]
          }
        },
      ]
    };

    const docDefinitions: any = {
      pageSize: 'A4',
      pageMargins: [50, 0, 50, 50],
      content: [

        {
          layout: 'Borders',
          style: 'tableExample',
          table: {
            headerRows: 1,
            widths: ['*'],
            body: [
              [{ text: this.dadosEmpresa?.razao || '', bold: true, alignment: 'center', margin: [0, 5, 0, 0], fontSize: 12, border: [false, false, false, false] },],
              [{ text: 'CNPJ: ' + (Funcoes.FormatDoc(this.dadosEmpresa?.cnpj_cpf) || ''), bold: true, alignment: 'center', margin: [0, 1, 0, 0], fontSize: 12, border: [false, false, false, false] },],

            ],
          },
        },

        {
          //[left, top, right, bottom]
          layout: 'noBorders',
          style: 'tableExample',
          table: {
            widths: ['100%'],
            body: [
              [{ text: 'Relatório de Produtos', alignment: 'center', fontSize: 15, style: 'header', margin: [0, 1, 0, 1] }],
            ],

          },

        },

        this.datai !== '' || this.dataf !== '' || this.nomeMarca !== '' || this.nomeGrupo !== '' || this.nomeSubGrupo !== '' || this.nomeTrib || this.tipoProduto !== '' || this.ativo !== '' || this.estoqueFisico !== '' ?
          {
            //[left, top, right, bottom]
            layout: 'noBorders',
            style: 'tableExample',
            table: {
              widths: ['100%'],
              body: [
                [{ text: 'Filtros Do Relatório: ', bold: true, margin: [0, 0, 0, 0], fontSize: 10, border: [true, true, true, true] }],

              ],

            },

          } : null,

        this.datai !== '' || this.tipoProduto !== '' ?
          {
            layout: 'noBorders',
            style: 'tableExample',
            margin: [0, 0, 0, 0],
            table: {
              widths: ['*', '*'],
              body: [
                [
                  this.datai !== '' ?
                    {
                      text: [
                        { text: 'Data Cadastro: ', fontSize: 9 },
                        { text: this.datai, fontSize: 10, bold: true },
                        { text: this.dataf !== '' ? '   à   ' : '', fontSize: 9 },
                        { text: this.dataf, fontSize: 10, bold: true }
                      ],
                      margin: [0, 0, 0, 0],
                    } : null,

                  this.tipoProduto !== '' ?
                    {
                      text: [
                        { text: 'Tipo Produto: ', fontSize: 9 },
                        { text: this.tipoProduto, fontSize: 10, bold: true },
                      ],
                      margin: [0, 0, 0, 0]
                    } : null,
                ],
              ],
            },
          } : null,

        this.nomeMarca !== '' ?
          {
            layout: 'noBorders',
            style: 'tableExample',
            margin: [0, 0, 0, 0],
            table: {
              widths: ['*'],
              body: [
                [
                  this.nomeMarca !== '' ?
                    {
                      text: [
                        { text: 'Marca: ', fontSize: 9 },
                        { text: this.nomeMarca, fontSize: 10, bold: true },
                      ],
                      margin: [0, 0, 0, 0]

                    } : null,
                ],
              ],
            },
          } : null,

        this.nomeGrupo !== '' ?
          {
            layout: 'noBorders',
            style: 'tableExample',
            margin: [0, 0, 0, 0],
            table: {
              body: [
                [
                  this.nomeGrupo !== '' ?
                    {
                      text: [
                        { text: 'Grupo: ', fontSize: 9 },
                        { text: this.nomeGrupo, fontSize: 10, bold: true },
                      ],
                      margin: [0, 0, 0, 0]
                    } : null,
                ],
              ],
            },

          } : null,

        this.nomeSubGrupo !== '' ?
          {
            layout: 'noBorders',
            style: 'tableExample',
            margin: [0, 0, 0, 0],
            table: {
              body: [
                [
                  this.nomeSubGrupo !== '' ?
                    {
                      text: [
                        { text: 'SubGrupo: ', fontSize: 9 },
                        { text: this.nomeSubGrupo, fontSize: 10, bold: true },
                      ],
                      margin: [0, 0, 0, 0]

                    } : null,
                ],
              ],
            },
          } : null,

        this.ativo !== '' || this.estoqueFisico !== ''  ?
          {
            layout: 'noBorders',
            style: 'tableExample',
            margin: [0, 0, 0, 0],
            table: {
              widths: ['*', '*'],
              body: [
                [
                  this.ativo !== '' ?
                    {
                      text: [
                        { text: 'Ativo: ', fontSize: 9 },
                        { text: this.ativo, fontSize: 10, bold: true },
                      ],
                      margin: [0, 0, 0, 0]

                    } : null,

                  this.estoqueFisico !== '' ?
                    {
                      text: [
                        { text: 'Estoque: ', fontSize: 9 },
                        { text: this.estoqueFisico, fontSize: 10, bold: true },
                      ],
                      margin: [0, 0, 0, 0]
                    } : null,
                ],
              ],
            },
          } : null,

        this.nomeTrib !== '' ?
          {
            layout: 'noBorders',
            style: 'tableExample',
            margin: [0, 0, 0, 0],
            table: {
              body: [
                [
                  this.nomeTrib !== '' ?
                    {
                      text: [
                        { text: 'Tributação: ', fontSize: 9 },
                        { text: this.nomeTrib, fontSize: 10, bold: true },
                      ],
                      margin: [0, 0, 0, 0]
                    } : null,
                ],
              ],
            },
          } : null,

        {
          layout: 'Borders',
          style: 'tableExample',
          margin: [0, 0, 0, 0],
          table: {
            //[left, top, right, bottom]
            widths: ['*', '15%', '15%', '10%'],
            body: [
              [
                { text: 'Descrição', alignment: 'left', fontSize: 11, margin: [0, 4, 0, 4], border: [false, true, false, false], bold: true },
                { text: 'Referência', alignment: 'left', fontSize: 11, margin: [0, 4, 0, 4], border: [false, true, false, false], bold: true },
                { text: 'Pr. Venda', alignment: 'right', fontSize: 11, margin: [0, 4, 0, 4], border: [false, true, false, false], bold: true },
                { text: 'Estoque', alignment: 'right', fontSize: 11, margin: [0, 4, 0, 4], border: [false, true, false, false], bold: true },
              ],
            ],
          },
        },

        {
          layout: 'Borders',
          style: 'tableExample',
          margin: [0, 0, 0, 0],
          table: {
            widths: ['*', '15%', '15%', '10%'],
            body: dados
          },
        }

      ],

      footer: footer
    };

    pdfMake.createPdf(docDefinitions).print();

  }

}